const TOKEN_IDENTIFIER = 'user_token';

export const saveToken = (token: string): void => window.sessionStorage.setItem(TOKEN_IDENTIFIER, token);

export const retrieveToken = (): string | null => window.sessionStorage.getItem(TOKEN_IDENTIFIER);

export const deleteSavedToken = (): void => window.sessionStorage.removeItem(TOKEN_IDENTIFIER);
